<ng-container *ngIf="section.title" [ngSwitch]="section.level">
  <h1 *ngSwitchCase="'0'">{{ section.title }}</h1>
  <h2 *ngSwitchCase="'1'">{{ section.title }}</h2>
  <h3 *ngSwitchDefault>{{ section.title }}</h3>
</ng-container>

<div class="translation-labels">
  <div>
    <strong>{{ originalLanguage.languageName }}</strong>
  </div>
  <div>
    <strong>{{ translationLanguage.languageName }}</strong>
  </div>
</div>

<mat-card appearance="outlined" class="section-card">
  <mat-card-content>
    <div class="section-card__content">
      <div *ngFor="let translation of section.translations; let translationIndex = index" class="grid__item" [formGroup]="getTranslationForm(translationIndex)">
        <p class="label--readonly">
          <strong>{{ translation.label }}</strong>
        </p>
        <div class="field--readonly" [attr.lang]="originalLanguage.languageCode">
          <ng-container [ngSwitch]="translation.fieldType">
            <ng-container *ngSwitchCase="'wysiwyg'">
              <div class="wysiwyg-content">
                <quill-view [content]="translation.msgId"></quill-view>
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ translation.msgId }}
            </ng-container>
          </ng-container>
        </div>
        <div class="field--buttons">
          <button mat-icon-button color="accent" [attr.aria-label]="getSwitchAriaLabel(translation)" (click)="switchTranslation(translation, translationIndex)">
            <mat-icon>input</mat-icon>
          </button>
          <button
            mat-icon-button
            color="warn"
            [attr.aria-label]="getDeleteAriaLabel(translation)"
            (click)="resetTranslation(translationIndex)">
            <mat-icon>history</mat-icon>
          </button>
          <!--
          <button mat-icon-button color="primary" [attr.aria-label]="getConfirmedAriaLabel(translation)" (click)="toggleConfirmed(translationIndex)">
            <mat-icon *ngIf="getTranslationForm(translationIndex).get('confirmed').value">check</mat-icon>
            <mat-icon *ngIf="!getTranslationForm(translationIndex).get('confirmed').value">spellcheck</mat-icon>
          </button>
           -->
          <!-- <mat-checkbox formControlName="confirmed" [attr.aria-label]="getConfirmedAriaLabel(translation)" i18n></mat-checkbox> -->
        </div>
        <ng-container [ngSwitch]="translation.fieldType">
          <mat-form-field class="field--editable" appearance="outline" *ngSwitchCase="'text'">
            <input [attr.lang]="translationLanguage.languageCode" matInput type="text" formControlName="msgStr" aria-label="Translation">
          </mat-form-field>
          <mat-form-field class="field--editable" appearance="outline" *ngSwitchCase="'textarea'">
            <textarea [attr.lang]="translationLanguage.languageCode" matInput formControlName="msgStr" aria-label="Translation"></textarea>
          </mat-form-field>
          <ng-container *ngSwitchCase="'wysiwyg'">
            <quill-editor class="field--editable" [attr.lang]="translationLanguage.languageCode" formControlName="msgStr" aria-label="Translation"></quill-editor>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<eas-translation-section
  *ngFor="let subSection of section.sections; let subSectionIndex = index"
  [section]="subSection"
  [sectionForm]="getSectionForm(subSectionIndex)"
  [originalLanguage]="originalLanguage"
  [translationLanguage]="translationLanguage"
></eas-translation-section>
